import { css } from "@emotion/css";
import { theme } from "assets/theme";
import { Text } from "components/common";
import { LockIcon } from "components/icons";
import { useNavigate } from "react-router-dom";
import { E_Route } from "utils/constants";

export const FreeCtaCard = () => {
  const navigation = useNavigate();
  const goToUpgrade = () => {
    navigation(E_Route.ManageBilling);
  };
  return (
    <div
      className={css`
        border-radius: 32px;
        border: 1px solid ${theme.colors.border.primary};
        background: ${theme.colors.background.secondary};
        backdrop-filter: blur(1.5px);
        width: 100%;
        min-height: 314px;
        padding: 40px 41px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      `}
    >
      <LockIcon
        fill="highlight/1"
        style={{ width: "32px", height: "32px", marginBottom: "16px" }}
      />
      <Text.BodyXS
        color="primary"
        marginBottom={0}
        style={{ textAlign: "center" }}
      >
        This feature is not available with your Free plan. Upgrade to see your
        upcoming meetings and get meeting preps for them.
      </Text.BodyXS>

      <button
        className={css`
          all: unset;
          border-radius: 47.139px;
          border: 1px solid #fff;

          margin-top: 34px;

          background: #fff;
          display: flex;
          padding: 8px 24px;
          justify-content: flex-end;
          align-items: flex-start;
          color: ${theme.colors.text.dark};
          cursor: pointer;
          font-size: 12px;
        `}
        onClick={goToUpgrade}
      >
        Upgrade plan
      </button>
    </div>
  );
};
